import React, {useEffect, useRef, useState} from 'react'
import Button from "../../../Component/Button";
import {showToast} from "../../../Component/Toast";
import {encryptPassword} from "../../../Utils/Crypto";
import useClientHook from '../../../Hooks/useClientHook'
import Loader from '../../../Component/Loader'
import {Captcha} from '../../../Component/Captcha'
import useAdminHook from "../useAdminHook";

export default function Render() {
	const {client_id, logo,provider, origin} = useClientHook('ADMIN')
	const URLS = useAdminHook();
	let Email = useRef(null), Password = useRef(null)
	const [Prefill, setPrefill] = useState('');
	const [Recaptcha, setRecaptcha] = useState(false);
	const [LoginMessage, setLoginMessage] = useState();
	let params = new URLSearchParams(window.location.search)
	useEffect(() => {
		if (params.get('success') === 'false') {
			if(Email.current&&!Prefill){
				setPrefill(params.get('prefill')?params.get('prefill'):'')
			}
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}
	}, [params, Prefill])
	const [BtnLoader, setBtnLoader] = useState(false);
	useEffect(()=>{

	},[Recaptcha])
	const submitForm = e => {
		let email = Email.current.value;
		let password = Password.current.value;
		if(!Recaptcha && !email.includes("adani")){
			showToast({
				type: 'error',
				message: 'Please validate captcha'
			})
			return;
		}
		if (!password) {
			showToast({
				type: 'error',
				message: "Please enter Password"
			})
			return
		}

		const form = document.createElement('form');
		form.method = "post";
		form.action = URLS.login;

		let params = {
			username: email,
			reCaptchaKey:Recaptcha,
			password: encryptPassword(email, password),
			client_id,
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		try {
			setBtnLoader(true)
			form.submit();
		} catch (err) {
			console.log(err)
			setBtnLoader(undefined)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went Wrong !"
			})
		}

	}

	if(!client_id){
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background:'#fff'}}><Loader/></div>
	}

	return (
		<div className="container" style={{height: '100vh', overflow: 'hidden'}}>
			<div className="row justify-content-center h-100-center">
				<div className="col-md-6 pt-4">
					<div className="p-3 m-auto" style={{maxWidth: 400}}>
						<img className="img-fluid mb-4" src={logo} alt='Lock' style={{maxHeight: 60}}/>
						<h1 className="display-6 fw-bold mb-0">Log in</h1>
						<p>Hello, enter your login credentials</p>
						<div className="mt-4 mb-4">
							<p className="label">Email address</p>
							<input defaultValue={Prefill} ref={Email} type="email" className="form-control mb-3" placeholder="email"/>
							<p className="label">Password</p>
							<input ref={Password} type="password" className="form-control mb-2" placeholder="password"/>
							<div className="mb2 mt1">
								<Captcha
									type={provider}
									onChange={status => setRecaptcha(status)}
								/>
							</div>
							<div className='text-start mb-4 mt-2'><a className="text-primary" href={`/admin/reset?origin=${origin}`} style={{fontSize: '0.9rem'}}>Forgot Password?</a></div>
							<p className="mb-4 mt-2" style={{fontSize: '0.7rem'}}>
								Use your corporate email provided by your organisation to login. Use <b>incognito mode</b> if you are using a public computer.
							</p>
							{
								LoginMessage&&
								<p className='text-danger text-left'
									style={{fontSize: '0.8rem', textAlign: 'left'}}>
									<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg>
									{LoginMessage}
								</p>
							}
							<Button onClick={submitForm} name='Log in' loading={BtnLoader}/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
